import type { IconName } from '../Sprite/Icon';
import type { ExternalAuthProvider } from '@/libs/auth/externalAuth';
import { useTranslations } from 'next-intl';
import { Icon } from '@/components/entities/Sprite';
import { Button } from '@/components/ui/Button/button';
import { externalAuth } from '@/libs/auth/externalAuth';
import { cn } from '@/utils/cn';

interface Props {
  getFingerprintRequestIdNoCache: () => Promise<string>;
  className?: string;
};

const PROVIDERS: Array<{
  provider: ExternalAuthProvider;
  icon: IconName;
  labelKey: 'continue-with-google' | 'continue-with-apple' | 'continue-with-facebook';
}> = [
  { provider: 'google', icon: 'google-logo', labelKey: 'continue-with-google' },
  { provider: 'apple', icon: 'apple', labelKey: 'continue-with-apple' },
  { provider: 'facebook', icon: 'auth-facebook', labelKey: 'continue-with-facebook' },
];

export const ExternalAuthButtons = ({
  getFingerprintRequestIdNoCache,
  className,
}: Props) => {
  const t = useTranslations('auth');

  return (
    <div className={cn('flex flex-col gap-4', className)}>
      {PROVIDERS.map(({ provider, icon, labelKey }) => (
        <Button
          key={provider}
          variant="secondary"
          type="button"
          className="w-full py-3"
          spanClassName="gap-1"
          onClick={async () => {
            const fingerprintRequestId = await getFingerprintRequestIdNoCache();
            externalAuth(provider, fingerprintRequestId);
          }}
        >
          <Icon name={icon} className="size-4" />
          <p className="paragraph-s-medium font-normal text-white tracking-[0.0063rem]">{t(labelKey)}</p>
        </Button>
      ))}
    </div>
  );
};
